/* eslint-disable */

import React, { createContext, useState, useEffect, useMemo } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { lightTheme, darkTheme } from "./theme"; // Import your themes

export const ThemeContext = createContext();

const ThemeContextProvider = ({ children }) => {
  // Retrieve the theme mode from local storage or default to "light"
  const [mode, setMode] = useState(
    () => localStorage.getItem("themeMode") || "light"
  );

  // Function to toggle the theme
  const toggleTheme = () => {
    const newMode = mode === "light" ? "dark" : "light";
    setMode(newMode);
    localStorage.setItem("themeMode", newMode); // Save to local storage
  };

  // Generate the theme object based on the current mode
  const theme = useMemo(
    () => (mode === "light" ? createTheme(lightTheme) : createTheme(darkTheme)),
    [mode]
  );

  // Effect to sync the theme mode with local storage on initial load
  useEffect(() => {
    const storedMode = localStorage.getItem("themeMode");
    if (storedMode) {
      setMode(storedMode);
    }
  }, []);

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <CssBaseline /> {/* Adds baseline styles for the theme */}
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeContextProvider;
